// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.slot-games-development-company-section {
  padding: 4rem 0;
  margin: 0 auto;
}
.slot-games-development-company-section .slot-games-development-company-wrap {
  width: 100%;
  max-width: var(--containerWidth);
  margin: 0 auto;
}
.slot-games-development-company-section .slot-games-development-company-wrap .slot-games-development-company-box {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  gap: 2.25rem;
  padding: 4.5rem 0;
  position: relative;
}
.slot-games-development-company-section .slot-games-development-company-wrap .slot-games-development-company-box::before {
  content: "";
  width: 200%;
  height: 100%;
  background-color: var(--secondaryMain-1000);
  z-index: -1;
  pointer-events: none;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.slot-games-development-company-section .slot-games-development-company-wrap .slot-games-development-company-box .chips-box {
  width: 100%;
  max-width: 73.375rem;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  gap: 1.75rem;
  margin: 0 auto;
}
.slot-games-development-company-section .slot-games-development-company-wrap .slot-games-development-company-box .chip {
  min-height: 4rem;
  border: 2px dashed var(--black-1000);
  border-radius: 1rem;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 0.75rem;
  padding: 1rem 2.5rem;
}
.slot-games-development-company-section .slot-games-development-company-wrap .slot-games-development-company-box .chip .icon-box {
  width: 1.5rem;
  min-width: 1.5rem;
  height: 1.5rem;
  display: flex;
  justify-content: center;
  align-items: center;
}
.slot-games-development-company-section .slot-games-development-company-wrap .slot-games-development-company-box .chip .icon-box svg {
  width: 100%;
  height: 100%;
  fill: var(--quaternaryMain-1000);
}
.slot-games-development-company-section .slot-games-development-company-wrap .slot-games-development-company-box .chip .chip-label-text {
  color: var(--black-1000);
  font-size: 1.5rem;
  font-weight: 500;
  line-height: 1.4;
  display: block;
}
.slot-games-development-company-section .slot-games-development-company-wrap .slot-games-development-company-box .text-box {
  width: 100%;
  max-width: 73.375rem;
  margin: 0 auto;
}
.slot-games-development-company-section .slot-games-development-company-wrap .slot-games-development-company-box .text-box .para-text {
  color: var(--black-1000);
  font-size: 1.5rem;
  font-weight: 400;
  line-height: 1.4;
  text-align: center;
}
.slot-games-development-company-section .slot-games-development-company-wrap .slot-games-development-company-box .img-box {
  width: 100%;
  max-width: 49rem;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 auto 0;
}
.slot-games-development-company-section .slot-games-development-company-wrap .slot-games-development-company-box .img-box img {
  width: 100%;
  max-width: 100%;
  height: auto;
}
@media screen and (max-width: 991.98px) {
  .slot-games-development-company-section {
    padding: 2.5rem 0;
  }
  .slot-games-development-company-section .slot-games-development-company-wrap .slot-games-development-company-box {
    gap: 1.75rem;
    padding: 3rem 0;
  }
  .slot-games-development-company-section .slot-games-development-company-wrap .slot-games-development-company-box .chips-box {
    gap: 1.25rem;
  }
  .slot-games-development-company-section .slot-games-development-company-wrap .slot-games-development-company-box .chip {
    min-height: 2.5rem;
    border-radius: 0.75rem;
    padding: 0.5rem 1.25rem;
  }
  .slot-games-development-company-section .slot-games-development-company-wrap .slot-games-development-company-box .chip .icon-box {
    width: 1rem;
    min-width: 1rem;
    height: 1rem;
  }
  .slot-games-development-company-section .slot-games-development-company-wrap .slot-games-development-company-box .chip .chip-label-text {
    font-size: 1rem;
  }
  .slot-games-development-company-section .slot-games-development-company-wrap .slot-games-development-company-box .text-box .para-text {
    font-size: 1rem;
  }
}
@media screen and (max-width: 767.98px) {
  .slot-games-development-company-section {
    padding: 2rem 0;
  }
  .slot-games-development-company-section .slot-games-development-company-wrap .slot-games-development-company-box {
    gap: 1.25rem;
    padding: 2.5rem 0;
  }
  .slot-games-development-company-section .slot-games-development-company-wrap .slot-games-development-company-box .chips-box {
    gap: 1rem;
  }
  .slot-games-development-company-section .slot-games-development-company-wrap .slot-games-development-company-box .chip {
    min-height: 2.25rem;
    border-radius: 0.5rem;
    padding: 0.5rem 1.25rem;
  }
  .slot-games-development-company-section .slot-games-development-company-wrap .slot-games-development-company-box .chip .icon-box {
    width: 0.875rem;
    min-width: 0.875rem;
    height: 0.875rem;
  }
  .slot-games-development-company-section .slot-games-development-company-wrap .slot-games-development-company-box .chip .chip-label-text {
    font-size: 0.875rem;
  }
  .slot-games-development-company-section .slot-games-development-company-wrap .slot-games-development-company-box .text-box .para-text {
    font-size: 0.875rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/SlotGamesDevelopmentCompanySection/SlotGamesDevelopmentCompanyStyle.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,cAAA;AACF;AACE;EACE,WAAA;EACA,gCAAA;EACA,cAAA;AACJ;AACI;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,sBAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;AACN;AACM;EACE,WAAA;EACA,WAAA;EACA,YAAA;EACA,2CAAA;EACA,WAAA;EACA,oBAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;AACR;AAEM;EACE,WAAA;EACA,oBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;EACA,YAAA;EACA,cAAA;AAAR;AAGM;EACE,gBAAA;EACA,oCAAA;EACA,mBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;EACA,oBAAA;AADR;AAGQ;EACE,aAAA;EACA,iBAAA;EACA,cAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AADV;AAGU;EACE,WAAA;EACA,YAAA;EACA,gCAAA;AADZ;AAKQ;EACE,wBAAA;EACA,iBAAA;EACA,gBAAA;EACA,gBAAA;EACA,cAAA;AAHV;AAOM;EACE,WAAA;EACA,oBAAA;EACA,cAAA;AALR;AAOQ;EACE,wBAAA;EACA,iBAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;AALV;AASM;EACE,WAAA;EACA,gBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;AAPR;AASQ;EACE,WAAA;EACA,eAAA;EACA,YAAA;AAPV;AAaE;EA3GF;IA4GI,iBAAA;EAVF;EAaI;IACE,YAAA;IACA,eAAA;EAXN;EAaM;IACE,YAAA;EAXR;EAcM;IACE,kBAAA;IACA,sBAAA;IACA,uBAAA;EAZR;EAcQ;IACE,WAAA;IACA,eAAA;IACA,YAAA;EAZV;EAeQ;IACE,eAAA;EAbV;EAkBQ;IACE,eAAA;EAhBV;AACF;AAsBE;EAhJF;IAiJI,eAAA;EAnBF;EAsBI;IACE,YAAA;IACA,iBAAA;EApBN;EAsBM;IACE,SAAA;EApBR;EAuBM;IACE,mBAAA;IACA,qBAAA;IACA,uBAAA;EArBR;EAuBU;IACA,eAAA;IACA,mBAAA;IACA,gBAAA;EArBV;EAwBQ;IACE,mBAAA;EAtBV;EA2BQ;IACE,mBAAA;EAzBV;AACF","sourcesContent":[".slot-games-development-company-section {\n  padding: 4rem 0;\n  margin: 0 auto;\n\n  .slot-games-development-company-wrap {\n    width: 100%;\n    max-width: var(--containerWidth);\n    margin: 0 auto;\n\n    .slot-games-development-company-box {\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      flex-direction: column;\n      gap: 2.25rem;\n      padding: 4.5rem 0;\n      position: relative;\n\n      &::before {\n        content: \"\";\n        width: 200%;\n        height: 100%;\n        background-color: var(--secondaryMain-1000);\n        z-index: -1;\n        pointer-events: none;\n        position: absolute;\n        top: 50%;\n        left: 50%;\n        transform: translate(-50%, -50%);\n      }\n\n      .chips-box {\n        width: 100%;\n        max-width: 73.375rem;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        flex-wrap: wrap;\n        gap: 1.75rem;\n        margin: 0 auto;\n      }\n\n      .chip {\n        min-height: 4rem;\n        border: 2px dashed var(--black-1000);\n        border-radius: 1rem;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        gap: 0.75rem;\n        padding: 1rem 2.5rem;\n\n        .icon-box {\n          width: 1.5rem;\n          min-width: 1.5rem;\n          height: 1.5rem;\n          display: flex;\n          justify-content: center;\n          align-items: center;\n\n          svg {\n            width: 100%;\n            height: 100%;\n            fill: var(--quaternaryMain-1000);\n          }\n        }\n\n        .chip-label-text {\n          color: var(--black-1000);\n          font-size: 1.5rem;\n          font-weight: 500;\n          line-height: 1.4;\n          display: block;\n        }\n      }\n\n      .text-box {    \n        width: 100%;\n        max-width: 73.375rem;\n        margin: 0 auto;\n\n        .para-text {\n          color: var(--black-1000);\n          font-size: 1.5rem;\n          font-weight: 400;\n          line-height: 1.4;\n          text-align: center;\n        }\n      }\n\n      .img-box {\n        width: 100%;\n        max-width: 49rem;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        margin: 0 auto 0;\n\n        img {\n          width: 100%;\n          max-width: 100%;\n          height: auto;\n        }\n      }\n    }\n  }\n\n  @media screen and (max-width: 991.98px) {\n    padding: 2.5rem 0;\n\n    .slot-games-development-company-wrap {  \n      .slot-games-development-company-box {\n        gap: 1.75rem;\n        padding: 3rem 0;\n\n        .chips-box {\n          gap: 1.25rem;\n        }\n\n        .chip {\n          min-height: 2.5rem;\n          border-radius: 0.75rem;\n          padding: 0.5rem 1.25rem;\n\n          .icon-box {\n            width: 1rem;\n            min-width: 1rem;\n            height: 1rem;\n          }\n  \n          .chip-label-text {\n            font-size: 1rem;\n          }\n        }\n\n        .text-box {      \n          .para-text {\n            font-size: 1rem;\n          }\n        }\n      }\n    }\n  }\n\n  @media screen and (max-width: 767.98px) {\n    padding: 2rem 0;\n\n    .slot-games-development-company-wrap {  \n      .slot-games-development-company-box {\n        gap: 1.25rem;\n        padding: 2.5rem 0;\n\n        .chips-box {\n          gap: 1rem;\n        }\n\n        .chip {\n          min-height: 2.25rem;\n          border-radius: 0.5rem;\n          padding: 0.5rem 1.25rem;\n          \n            .icon-box {\n            width: 0.875rem;\n            min-width: 0.875rem;\n            height: 0.875rem;\n          }\n  \n          .chip-label-text {\n            font-size: 0.875rem;\n          }\n        }\n\n        .text-box {      \n          .para-text {\n            font-size: 0.875rem;\n          }\n        }\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
